<script>
import {ref} from "vue";
import {useRoute} from "vue-router";
import loadingPage from "@/components/assetComponents/LoadingPage.vue";
import Swal from "sweetalert2";
import FreeWorld from "@/assets/js/FreeWorld";
import Swals from "@/assets/js/Swals";
import {useStore} from "vuex";

export default {
  name: 'RegisterPage',
  components: {loadingPage},
  setup() {
    document.body.scrollTop = 0
    document.documentElement.scrollTop = 0

    let loading = ref(false)

    let store = useStore()

    let phone = useRoute().params.phone

    let item_state = ref([])
    let item_city = ref([])
    let state_id = ref();
    let city_id = ref();
    let name = ref('')
    let ref_code = ref('')

    function get_country() {
      loading.value = true

      FreeWorld.Heisenberg({}, 'user/city').then((res) => {

        loading.value = false
        item_state.value = res.data.results
        state_id.value = item_state.value[0].id
        item_city.value = item_state.value[0].city
        city_id.value = item_city.value[0].id

      }).catch((result) => {
        loading.value = false
        Swals.Catch(result, get_country)
      })
    }
    get_country()

    function change_state() {
      item_state.value.forEach(item => {
        if (state_id.value == item.id) {
          item_city.value = item.city
          city_id.value = item.city[0].id
        }
      });
    }


    function send_code() {
      if (name.value.trim().length === 0) {

        Swal.fire({
          icon: 'warning',
          title: 'لطفا نام خود را وارد کنید.',
          confirmButtonText: 'متوجه شدم',
          showClass: {
            popup: 'animate__animated animate__bounceInDown'
          },
          hideClass: {
            popup: 'animate__animated animate__bounceOutUp'
          }
        })

      } else {

        let data = {
          phone: phone,
          full_name: name.value,
          state_id: state_id.value,
          city_id: city_id.value,
          ref_code: ref_code.value,
        }

        loading.value = true

        FreeWorld.Heisenberg(data, 'signUp').then((result) => {

          loading.value = false
          var res = result.data

          if (res.status === 'ok') {

            FreeWorld.Heisenberg({action: 'show',user_id:res.id}, 'user_edit').then((result) => {

              let res = result.data
              store.commit('set_my_profile', res)

              localStorage.setItem('uid', FreeWorld.PinkMan(res.id , 'en'))
              window.location.href = '/HomePage'

            }).catch((res)=>{
              loading.value = false
              Swals.Catch(res, send_code)
            })

          } else if(res.event === 'error_ref_code'){

            Swals.Warning('کد معرف وارد شده اشتباه است')

          }else {
            Swal.fire({
              icon: 'error',
              title: 'متاسفانه مشکلی رخ داده است',
              confirmButtonText: 'متوجه شدم',
              showClass: {
                popup: 'animate__animated animate__bounceInDown'
              },
              hideClass: {
                popup: 'animate__animated animate__bounceOutUp'
              }
            })
          }

        }).catch((result) => {
          loading.value = false
          Swals.Catch(result, send_code)
        })
      }
    }


    return {
      loading,
      send_code,
      name,
      state_id,
      city_id,
      item_city,
      item_state,
      change_state,
      ref_code,
    }
  }
}
</script>

<template>
  <LoadingPage v-if="loading"></LoadingPage>

  <div id="main" :class="loading ? 'activeClass' : '' " class="animate__animated animate__fadeIn position-relative">
    <img class="bg-login" src="../assets/img/bg-login.png" alt=""/>
    <div class="w-100 position-relative">
      <br>
      <br>
      <br>
      <br>
      <img class="img-logo d-block mx-auto mb-5" src="../assets/img/logo_app.svg" alt=""/>
      <img style="height: 3.1rem" class="d-block mx-auto" src="../assets/img/logo_splash.png" alt=""/>
    </div>
    <br>
    <br>
    <div class="div-blur d-block mx-auto p-body">
      <br>
      <br>
      <p style="text-shadow: 2px 2px 2px #6e6d6d;" class="font-3  text-white text-center">
        لطفا استان و شهر مورد نظر خود را انتخاب کنید
      </p>
      <br>

      <div class="position-relative">
        <input
            v-model="name"
            class="p-3 w-100 text-center rounded-pill shadow d-block mx-auto font-5 bg-white"
            type="text"
            placeholder="نام و نام خانوادگی"
        />
        <img class="icon-phone " src="../assets/img/icon_user.svg" alt=""/>
      </div>
      <!-- == -->
      <div class="position-relative mt-2 ">
        <select
            v-model="state_id"
            @change="change_state"
            class="w-100 p-3 text-center rounded-pill shadow d-block mx-auto font-5 bg-white">

          <option v-for="item in item_state" :key="item.id" :value="item.id">{{ item.name }}</option>

        </select>
        <img class="icon-phone " src="../assets/img/location.svg" alt=""/>
      </div>
      <!-- == -->
      <div class="position-relative mt-2">
        <select
            v-model="city_id"
            class="p-3 w-100 text-center rounded-pill shadow d-block mx-auto font-5 bg-white">
          <option
              v-for="item in item_city" :key="item.id" :value="item.id">{{ item.name }}
          </option>
        </select>
        <img class="icon-phone " src="../assets/img/location.svg" alt=""/>
      </div>
      <!-- == -->
      <div class="position-relative mt-2">
        <input
            v-model="ref_code"
            class="p-3 w-100 text-center rounded-pill shadow d-block mx-auto font-5 bg-white"
            type="text"
            placeholder="کد معرف"
        />
        <img class="icon-phone " src="../assets/img/icon_user.svg" alt=""/>
      </div>

      <br>
      <br>
      <div style="height: 3rem">
        <v-btn
            @click="send_code"
            class="bg-color shadow-lg text-white btn-number d-block mx-auto h-100 rounded font-5"
            type="submit"
        >
          ثبت نام
        </v-btn>
      </div>
    </div>
  </div>

  <div id="web" :class="loading ? 'activeClass' : '' " class="animate__animated animate__fadeIn position-relative bg-color-holder">
    <div class="center-y w-100">
      <div class="div-blur d-block mx-auto p-body">
        <br>
        <br>
        <p style="text-shadow: 2px 2px 2px #6e6d6d;" class="font-3  text-white text-center">
          لطفا استان و شهر مورد نظر خود را انتخاب کنید
        </p>
        <br>
        <div class="d-flex position-relative">
          <input
              v-model="name"
              class="input-number rounded-pill d-block mx-auto font-5 bg-white"
              type="text"
              placeholder="نام و نام خانوادگی"
          />
          <img class="icon-phone " src="../assets/img/icon_user.svg" alt=""/>
        </div>

        <div class="d-flex mt-2 position-relative">
          <select
              v-model="state_id"
              @change="change_state"
              class="input-number rounded-pill d-block mx-auto font-5 bg-white"
              type="text">

            <option v-for="item in item_state" :key="item.id" :value="item.id">{{ item.name }}</option>

          </select>
          <img class="icon-phone " src="../assets/img/location.svg" alt=""/>
        </div>
        <!-- == -->
        <div class="d-flex mt-2 position-relative">
          <select
              v-model="city_id"
              class="input-number rounded-pill d-block mx-auto font-5 bg-white"
              type="text">
            <option
                v-for="item in item_city" :key="item.id" :value="item.id">{{ item.name }}</option>
          </select>
          <img class="icon-phone " src="../assets/img/location.svg" alt=""/>
        </div>
        <!-- == -->

        <div class="position-relative mt-2">
          <input
              v-model="ref_code"
              class="input-number text-center rounded-pill shadow d-block mx-auto font-5 bg-white"
              type="text"
              placeholder="کد معرف"
          />
          <img class="icon-phone " src="../assets/img/icon_user.svg" alt=""/>
        </div>

        <br>
        <br>
        <button
            @click="send_code"
            class="bg-color shadow-lg text-white btn-number d-block mx-auto rounded font-5"
            type="submit"
        >
          ثبت نام
        </button>
      </div>
    </div>
  </div>
</template>

<style scoped>
.bg-color-holder {
  background-image: linear-gradient(to top, #FFAF73, #FF9900);
}
.bg-login {
  position: absolute;
  top: -5px;
  right: -5px;
  width: 103%;
  max-width: 700px;
}

.img-logo {
  height: 160px;
}

.div-blur {
  background-color: rgba(255, 255, 255, 0.2);
  /* background-color: #1a1222; */
  border-radius: 30px;
  width: 90%;
  max-width: 470px;
  /* filter: blur(1px); */
  /* -webkit-filter: blur(8px); */
  -webkit-backdrop-filter: blur(10px);
  height: 400px;
  /* opacity: 0.8; */
  top: 20px;
  position: relative;
  /* z-index: 1; */
  backdrop-filter: saturate(1) blur(10px);
  /* backdrop-filter: blur(100px); */
}

.input-number {
  width: 100%;
  height: 48px;
  line-height: 45px;
  border: none;
  text-align: center;
  /* box-shadow: 0 0 15px rgb(212, 212, 212); */
}

.icon-phone {
  width: 2.5rem;
  position: absolute;
  text-align: center;
  right: .1rem;
  top: 52%;
  transform: translate(0 , -50%);
}

.btn-number {
  width: 60%;
  border: none;
  line-height: 40px;
}

</style>